module.exports = __webpack_public_path__ + "static/img/off_coupon.d0bd6b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/off_coupon.png
// module id = Byd/
// module chunks = 1